<template>
  <list-layout :tableTools='toggleTableTools'>
    <template slot='header'>
      <BaseHeader :content='header' />
    </template>
    <template slot='table-core'>
      <base-table-pagination
        ref="baseTablePagRef"
        :total='pagination.total'
        :currentPage='pagination.currentPage'
        :perPage='pagination.pageSize'
        @changeCurrentPage='changeCurrentPage'
        @changePerPage='changePerPage'
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-columnas-medatados v-if="hasModuleColumnasDinamicas" @toggleColumnasMetadatosDialog="toggleColumnasMetadatosDialog" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot='table-tags'>
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot='table-component'>
      <kendo-grid-component
        :spanish="spanish"
        :dataResult='kendo.dataResult'
        :kendo="kendo"
        :loading='isGeneralLoading'
        :selectedField="selectedField"
        @datastatechange='dataStateChange'
        @columnreorder='columnReorder'
        @rowclick='openPath'
        @columnssubmit='onColumnsSubmit'
        @sortchange='sortChange'
        @filterchange='filterChange'
        @selectionchange="onSelectionChange"
        @headerselectionchange="onHeaderSelectionChange">
      </kendo-grid-component>
    </template>
    <template slot='layout-extend'>
      <base-table-select-actions-expand
        :visibility="hasSelected"
        :selected="rowsSelected"
        :total="rowsTotal"
        :baseDropDownVisible="isMoreActionsVisible && hasSelected"
      >
        <template slot="commons">
          <base-button :disabled="!hasSelected" size="xs" mode="tools" @click="unselect">
            <base-icon name="vall" size="sm" class="mr-1" :ariaHidden="true"/>
            {{ $t('app.unselect') }}
          </base-button>
        </template>
        <template slot="more">
          <span v-for="action in accionesGeneral" :key="action.IdAccion">
            <base-button-item-list theme="dark" @click="executeAction(action)" :disabled="isGeneralLoading" >
              <base-icon :name="selectIcon(action.IdAccion)" class="mr-2" :ariaHidden="true"/>
                {{ action.Descripcion }}
            </base-button-item-list>
          </span>
        </template>
      </base-table-select-actions-expand>
      <base-footer>
        <template slot='actions'>
          <base-table-select-actions-form 
            ref="baseTableSelectActionsFormAPIRequests"
            v-if="hasModuleAPIRequests && peticionesAPIAccionesFilter && peticionesAPIAccionesFilter.length > 0 && hasSelected"
            :baseDropDownVisible="peticionesAPIAccionesFilter && peticionesAPIAccionesFilter.length > 0"
            :name="'Enviar Petición a API'"
            >
            <template slot="more">
              <span v-for="action in peticionesAPIAccionesFilter" :key="action.idPeticion">
                <base-button-item-list theme="dark" @click="showActionModal(action)" :disabled="isGeneralLoading" :loading="isGeneralLoading">
                  <base-icon name="send" class="mr-2" :ariaHidden="true"/>
                  <div class="w-72 text-left">
                    {{ action.NombreAccion }}
                  </div>
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading="isGeneralLoading || loader" :disabled="loader"/>
          <base-button-responsive v-if="hasModuleImportaciones && role === 'SuperAdministrador'" mode='primary' :text="$t('app.import_neos_xml_pad')" icon='import' @click='toggleImportNeosPaD' :loading='isGeneralLoading'/>
          <base-button-responsive v-if="hasModuleImportaciones && role === 'SuperAdministrador'" mode='primary' :text="$t('app.import_neos_xml_desc')" icon='import' @click='toggleImportNeos' :loading='isGeneralLoading'/>
          <base-button-responsive v-if="role !== 'UsuarioConsulta'" mode="primary" :text="$t('app.add_notification')" icon="plus" @click="goToNewNotification" :loading="isGeneralLoading"/>
        </template>
      </base-footer>
      <input-select-org-province-dialog 
        :header="$t('organismoprovincia.add')"
        :headerValue="$t('organismoprovincia.title')"
        :dialogOpen="showModalOrgProvince" 
        @toggleDialog="toggleModalOrgProvince" 
        @applyDialog="sendUpdateOrgProvinceAndPetitionAPI"
        :idCliente="idClienteSelected"
        />
      <import-xml-dialog
        :vuexNamespace="vuexnamespace"
        :activateSwitchs="false"
        :sizeLg="role !== 'Administrador'"
        :dialogOpen="showModalImportNeos"
        @toggleDialog="toggleImportNeos"
        @applyDialog="applyImportNeos"
        @downloadTemplate="downloadTemplateNeos"
        header="Importación de Notificaciones descargadas por múltiples XML" 
        />
      <import-xml-dialog
        :vuexNamespace="vuexnamespace"
        :activateSwitchs="false"
        :sizeLg="role !== 'Administrador'"
        :dialogOpen="showModalImportNeosPaD"
        @toggleDialog="toggleImportNeosPaD"
        @applyDialog="applyImportNeosPaD"
        @downloadTemplate="downloadTemplateNeosPaD"
        :maxFiles="1"
        header="Importación de Notificaciones puestas a disposición por XML" 
        />
        <BaseElDialog
          title="Descargar notificación"
          :visible.sync="showModal"
          @open="handleOpenModalDialog('container-handleOpenModalDialog')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModalDialog">
              <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {downloadHandler(); showModal = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Archivar sin descargar"
          :visible.sync="showModalArchivar"
          @open="handleOpenModalDialog('container-handleOpenModal-archivar')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageArchivar }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-archivar">
              <base-button class="w-full" @click="showModalArchivar = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {archivarHandler(); showModalArchivar = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Aplicar reglas de reparto"
          :visible.sync="showModalApplyRules"
          @open="handleOpenModalDialog('container-handleOpenModal-apply-rules')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageApplyRules }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-apply-rules">
              <base-button class="w-full" @click="showModalApplyRules = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyRulesManualHandler(); showModalApplyRules = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Borrar notificación"
          :visible.sync="showModalDelete"
          @open="handleOpenModalDialog('container-handleOpenModal-delete-neo')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-neo">
              <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {deleteHandler(); showModalDelete = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Pasar notificación a tramitada"
          :visible.sync="showModalTramitar"
          @open="handleOpenModalDialog('container-handleOpenModal-tramitar-neo')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageTramitar }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-tramitar-neo">
              <base-button class="w-full" @click="showModalTramitar = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {tramitarHandler(); showModalTramitar = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
            title="Desvincular grupos"
            :visible.sync="showModalUnlinkGroups"
            @open="handleOpenModalDialog('container-handleOpenModal-unlink-groups')"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
            <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkGroups }}</span>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-unlink-groups">
                <base-button class="w-full" @click="showModalUnlinkGroups = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkGroupsHandler(); showModalUnlinkGroups = false}"/>
              </div>
            </template>
        </BaseElDialog>
        <BaseElDialog
            title="Vincular grupos"
            :visible.sync="showModalLinkGroups"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-vinc-groups-body',
              'container-handleOpenModal-vinc-groups',
              ])"
            :close-on-click-modal="!isSelectDropdownOpen"
            @closed="releaseFocusDialog"
            width="40%"
            custom-class="min-width-dialog"
            center
            :show-close="false">
              <div 
                class="overflow-x-hidden"
                ref="container-handleOpenModal-vinc-groups-body"
                :style="{'height':heightContainerSelect}"
                >
                <el-form
                  ref="ruleForm"
                >
                  <div class="">
                    <div>
                      <AccessibleElSelect
                        v-model="listaGroupsSelected"
                        prop="listaGroupsSelected"
                        :options="groupsForAccessibleSelect"
                        :withFormItem="true"
                        :group="true"
                        :isMultiple="true"
                        :isDisabled="isLoadingSelect"
                        id-prefix="notifications"
                        @visible-change="onExpand"
                        @change="onChangeInput"
                      >
                        <template slot="label">{{$t('app.groups')}}</template>
                      </AccessibleElSelect>
                    </div>
                    <span v-if="processMessageVincularRepartoActive" v-html="processMessageVincularReparto" class="w-full dark:text-darkblue-200 inline-block word-break-n"/>
                  </div>
                  
                </el-form>
              </div>
            <template slot="footer" >
              <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-vinc-groups">
                <base-button class="w-full" v-if="isAllSelected" @click="handleUnSelectAll" mode="secondary-phantom-blue" :text="$t('app.unselect_all')" :disabled="!isLoadedData || isLoadingSelect" :loading="isLoadingSelect"/>
                <base-button class="w-full" v-if="!isAllSelected" :disabled="!isLoadedData || isLoadingSelect || isEmptyList" @click="handleSelectAll" mode="secondary-phantom-blue" :text="$t('app.select_all')" :loading="isLoadingSelect"/>
                <div class="w-48"></div>
                <base-button class="w-full" @click="showModalLinkGroups = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"
                  :loading="isLoadingSelect"
                  :disabled="isLoadingSelect"
                  />
                <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkHandler(); showModalLinkGroups = false}"
                  :loading="isLoadingSelect"
                  :disabled="isLoadingSelect"
                  />
              </div>
            </template>
        </BaseElDialog>
        <BaseElDialog
          :title="$t('app.user_responsable_unlink')"
          :visible.sync="showModalUnlinkUserResponsable"
          @open="handleOpenModalDialog('container-handleOpenModal-unlink-user-responsable')"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
          <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageUnlinkUserResponsable }}</span>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-unlink-user-responsable">
              <base-button class="w-full" @click="showModalUnlinkUserResponsable = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {unlinkUserResponsableHandler(); showModalUnlinkUserResponsable = false}"/>
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          :title="$t('app.user_responsable_reasign')"
          :visible.sync="showUserResponsable"
          @open="handleOpenModalDialog([
            'container-handleOpenModal-userresponsable-prop-body',
            'container-handleOpenModal-userresponsable-prop',
            ])"
          :close-on-click-modal="!isSelectDropdownOpen"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
            <div 
              ref="container-handleOpenModal-userresponsable-prop-body"
              >
              <el-form
                ref="ruleForm"
              >
                <div>
                  <AccessibleElSelect
                    v-model="userResponsableSelected"
                    prop="userResponsableSelected"
                    :options="usersForAccessibleSelect"
                    :withFormItem="true"
                    :isDisabled="isLoadingSelect"
                    id-prefix="notifications"
                    @visible-change="onExpand"
                    @change="onChangeInput"
                  >
                    <template #label>
                        {{$t('configurations.username')}}
                    </template>
                  </AccessibleElSelect>
                </div>
              </el-form>
            </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-userresponsable-prop">
              <base-button class="w-full" @click="showUserResponsable = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"
                />
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyUserResponsableReasignHandler()}"
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"
                />
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          title="Reasignar propietario"
          :visible.sync="showModalLinkGroupsReasig"
            @open="handleOpenModalDialog([
              'container-handleOpenModal-reasign-prop-body',
              'container-handleOpenModal-reasign-prop',
              ])"
            :close-on-click-modal="!isSelectDropdownOpen"
            @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
            <div 
              ref="container-handleOpenModal-reasign-prop-body"
              >
              <el-form
                ref="ruleForm"
              >
                <div class="lg:mb-2">
                    <AccessibleElSelect
                      v-model="groupReasignSelected"
                      prop="groupReasignSelected"
                      :options="groupsForAccessibleSelect"
                      :withFormItem="true"
                      :group="true"
                      :isDisabled="isLoadingSelect"
                      id-prefix="notifications"
                      @visible-change="onExpand"
                      @change="onChangeInput"
                    >
                      <template slot="label">{{$t('app.groups')}}</template>
                    </AccessibleElSelect>
                  
                    <label for="switch-mantener-grupo-notifications" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                      {{$t('configurations.reasign_owner_option')}}
                    </label>
                    <el-switch 
                      id="switch-mantener-grupo-notifications"
                      :aria-label="$t('configurations.reasign_owner_option')"
                      class="switch-text break-normal mt-2" 
                      v-model="mantenerGrupo" 
                      :active-text="$t('app.active')">
                    </el-switch>
                </div>
              </el-form>
            </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-reasign-prop">
              <base-button class="w-full" @click="showModalLinkGroupsReasig = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"
                />
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {applyLinkReasignHandler(); showModalLinkGroupsReasig = false}"
                :loading="isLoadingSelect"
                :disabled="isLoadingSelect"
                />
            </div>
          </template>
        </BaseElDialog>
        <BaseElDialog
          :title="$t('app.exclusion_org')"
          :visible.sync="showModalOrganismo"
          @open="handleOpenModalDialog([
            'container-handleOpenModal-exclusion-org-body',
            'container-handleOpenModal-exclusion-org',
            ])"
          @closed="releaseFocusDialog"
          width="40%"
          custom-class="min-width-dialog"
          center
          :show-close="false">
            <div ref="container-handleOpenModal-exclusion-org-body" :class="{'mb-6': isLower1024}">
              <!-- <span :key="t" v-for="t in processMessageOrganismo" class="w-full dark:text-darkblue-200 inline-block word-break-n">{{ t }}</span> -->
              <span v-html="processMessageOrganismo" class="w-full dark:text-darkblue-200 inline-block word-break-n"/>
              <label for="switch-all-companies-exclude" class="sr-only">
                {{$t('app.exclusion_org')}}. {{$t('app.options')}}: {{$t('companies.actual_company')}} / {{$t('companies.all_companies')}}
              </label>
              <el-switch 
                id="switch-all-companies-exclude"
                :aria-label="$t('app.exclusion_org')"
                class="switch-text break-normal both-switch mt-6" 
                inactive-color="var(--primary-800)" 
                v-model="isAllCompaniesExcludeOrganismo" 
                :active-text="$t('companies.all_companies')" 
                :inactive-text="$t('companies.actual_company')"></el-switch>
            </div>
          <template slot="footer" >
            <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-exclusion-org">
              <base-button class="w-full" @click="showModalOrganismo = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
              <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {excluirOrganismo(); showModalOrganismo = false}"/>
            </div>
          </template> 
      </BaseElDialog>
      <BaseElDialog
        :title="$t('aiassist.accept_all')"
        :visible.sync="showModalAcceptSuggestIA"
        @open="handleOpenModalDialog('container-handleOpenModal-accept-suggest-ia')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageAcceptSuggestIA }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-accept-suggest-ia">
            <base-button class="w-full" @click="showModalAcceptSuggestIA = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {acceptSuggestIAHandler(); showModalAcceptSuggestIA = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <BaseElDialog
        :title="$t('aiassist.cancelar_all')"
        :visible.sync="showModalCancelSuggestIA"
        @open="handleOpenModalDialog('container-handleOpenModal-cancel-suggest-ia')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageCancelSuggestIA }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-cancel-suggest-ia">
            <base-button class="w-full" @click="showModalCancelSuggestIA = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {cancelSuggestIAHandler(); showModalCancelSuggestIA = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <input-text-dialog 
        :dialogOpen="showModalRechazo" 
        @toggleDialog="toggleMotivoRechazo" 
        @applyDialog="rechazoDialogHandler"
        header="Rechazar notificaciones" 
        headerValue="Motivo de rechazo" 
        :maxLength='1000'
        typeInput='textarea'
        />
      <input-text-mail-from-white-list-dialog 
        :dialogOpen="showModalWhiteMail" 
        @toggleDialog="newWhiteMailToggleDialog" 
        @applyDialog="applyNewWhiteMailDialog"
        header="Envío de la notificación por correo" 
        headerValue="Lista de emails"
        :idCliente="idClienteSelected"
        />
      <link-my-groups-dialog 
        :dialogOpen="showModalLinkMyGroups" 
        @toggleDialog="linkMyGroupsToggleDialog" 
        @applyDialog="applyLinkMyGroupsDialog" 
        :idCliente="idClienteSelected"
        />
      <download-z-i-p-dialog
        :dialogOpen="showModalDownloadZip" 
        @toggleDialog="downloadZipToggleDialog" 
        @applyDialog="applyDownloadZipDialog"
        />
      <filter-panel :panelOpen='filterPanel' @togglePanel='toggleFilters' @applyFilters='applyFiltersHandler' :status="status" />
      <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
      <columnas-panel 
        ref="columnasPanel" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="columnasMetadatosPanel" 
        @togglePanel="toggleColumnasMetadatosDialog" 
        @applyFilters="applyFiltersHandler" />
      <input-text-mail-from-white-list-vinculados-dialog 
        :dialogOpen="showModalTextoCorreo" 
        @toggleDialog="toggleTextoCorreo" 
        @applyDialog="applyTextoCorreo"
        header="Envío de la notificación por correo" 
        />
        <notification-new-metadata-dialog 
          :dialogOpen="showNewMetadato" 
          :idCliente="idClienteSelected"
          @toggleDialog="toggleDialogMetadato" 
          @applyDialog="applyDialogMetadatoHandler"
        />
    </template>
  </list-layout>
</template>

<script>
import { getApiBaseUrl, joinUrl } from '@/config/runtimeConfig'
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/NotificationsFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import ColumnasPanel from '@/components/searches/ColumnasPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import InputTextMailFromWhiteListDialog from '@/components/InputTextMailFromWhiteListDialog.vue'
import InputTextMailFromWhiteListVinculadosDialog from '@/components/InputTextMailFromWhiteListVinculadosDialog.vue'
import LinkMyGroupsDialog from '@/components/LinkMyGroupsDialog.vue'
import DownloadZIPDialog from '@/components/DownloadZIPDialog.vue'
import InputTextDialog from '@/components/InputTextDialog.vue'
import { getNotifications } from '@/services/notifications/getNotifications'
import { getNEOError } from '@/services/notices/getNEOError'
import { getNEOFinTramite } from '@/services/notices/getNEOFinTramite'
import { getNEOSinDescargar } from '@/services/notices/getNEOSinDescargar'
import { updateNotificationStatus } from '@/services/notifications/updateNotificationStatus'
import { i18n } from '@/i18n'
import { process as processKendo } from '@progress/kendo-data-query'
// import { saveExcel } from '@progress/kendo-vue-excel-export'
import KendoGridComponent from '../../components/KendoGridComponent.vue'
// import moment from 'moment'
import { downloadDocsNEO } from '@/services/app/downloadDocsNEO'
import { downloadExcel } from '@/services/app/downloadExcel'
import { downloadExcelError } from '@/services/notices/downloadExcelError'
import { downloadExcelFinTramite } from '@/services/notices/downloadExcelFinTramite'
import { downloadExcelSinDescargar } from '@/services/notices/downloadExcelSinDescargar'
import { load } from '@progress/kendo-vue-intl'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import numbers from 'cldr-numbers-full/main/es/numbers.json'
import currencies from 'cldr-numbers-full/main/es/currencies.json'
import caGregorian from 'cldr-dates-full/main/es/ca-gregorian.json'
import dateFields from 'cldr-dates-full/main/es/dateFields.json'
import timeZoneNames from 'cldr-dates-full/main/es/timeZoneNames.json'
import BaseElDialog from '@/components/base/BaseElDialog.vue'
import { bus } from '@/main'
import { TIPOS_ESTADOS_DESCARGA_DOWNLOADED } from '@/config/tipos-estados-descarga-downloaded'

import { getGroupsSimple } from '@/services/configurations/groups/getGroupsSimple'
import { getUsuariosByGrupo } from '@/services/configurations/groups/getUsuariosByGrupo'
import { asignarusuarioresponsableneos } from '@/services/notifications/asignarusuarioresponsableneos'

import { aceptarsugerencias } from '@/services/notifications/aceptarsugerencias'
import { rechazarsugerencias } from '@/services/notifications/rechazarsugerencias'
import { enviaraia } from '@/services/notifications/enviaraia'
import { reintentarenviosia } from '@/services/notifications/reintentarenviosia'
import { quitaravisoreincidenciaerrores } from '@/services/notifications/quitaravisoreincidenciaerrores'

import { linkNEOGroupsMultiple } from '@/services/configurations/groups/linkNEOGroupsMultiple'
import { unlinkNEOGroupsMultiple } from '@/services/configurations/groups/unlinkNEOGroupsMultiple'
import { linkNEOsGroupReasign } from '@/services/configurations/groups/linkNEOsGroupReasign'

import { addExclusionOrganismo } from '@/services/notifications/addExclusionOrganismo'
import { sendAvisoCorreoManual } from '@/services/notifications/sendAvisoCorreoManual'
import { quitarEnviarEmailError } from '@/services/notifications/quitarEnviarEmailError' 
import { reenviarEmailsErrorNEO } from '@/services/notifications/reenviarEmailsErrorNEO'
import { quitarPeticionAPIError } from '@/services/notifications/quitarPeticionAPIError' 
import { sendMailNEOVinculados } from '@/services/notifications/sendMailNEOVinculados' 
import { addMetadatoMasivo } from '@/services/notifications/addMetadatoMasivo' 
import { sendRejectNEO } from '@/services/notifications/sendRejectNEO'

import ImportXmlDialog from '@/components/ImportXmlDialog.vue'
import { importNeos } from '@/services/configurations/imports/importNeos'
import { downloadTemplateNeos } from '@/services/configurations/imports/downloadTemplateNeos'
import { importNeosPaD } from '@/services/configurations/imports/importNeosPaD'
import { downloadTemplateNeosPaD } from '@/services/configurations/imports/downloadTemplateNeosPaD'
import NotificationNewMetadataDialog from '../../components/NotificationNewMetadataDialog.vue'

import { getPeticionesAPIAcciones } from '@/services/clients/getPeticionesAPIAcciones' 
import { ejecutarPeticionApi } from '@/services/notifications/ejecutarPeticionApi'  
import { updateOrganismoProvinciaNEOs } from '@/services/notifications/updateOrganismoProvinciaNEOs'   
import { aplicarreglasneos } from '@/services/notifications/aplicarreglasneos'   

import InputSelectOrgProvinceDialog from '@/components/InputSelectOrgProvinceDialog.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { dropdownState } from '@/state/dropdownState'
import DOMPurify from 'dompurify'

load(
  likelySubtags,
  currencyData,
  weekData,
  numbers,
  currencies,
  caGregorian,
  dateFields,
  timeZoneNames
)

export default {
  name: 'list-neos-view',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent,
    InputTextMailFromWhiteListDialog,
    InputTextMailFromWhiteListVinculadosDialog,
    DownloadZIPDialog,
    BaseElDialog,
    LinkMyGroupsDialog,
    InputTextDialog,
    ImportXmlDialog,
    ColumnasPanel,
    NotificationNewMetadataDialog,
    InputSelectOrgProvinceDialog,
    AccessibleElSelect,
  },
  data: function () {
    return {
      heightSelect: 0,
      heightInput: 35,
      idVista: 1,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      columnasMetadatosPanel: false,
      // Link grupos
      listaGroups: [],
      loadingActionSelect: false,
      loadingActionUnSelect: false,
      isLoadedData: false,

      listaGroupsSelected: [],
      showModalLinkGroups: false,
      showModalUnlinkGroups: false,

      showModalLinkGroupsReasig: false,
      groupReasignSelected: null,
      mantenerGrupo: false,

      showModalImportNeos: false,
      showModalImportNeosPaD: false,

      showModalTextoCorreo: false,

      showNewMetadato: false,

      listaUsers: [],
      showUserResponsable: false,
      userResponsableSelected: null,

      showModalUnlinkUserResponsable: false,

      showModalAcceptSuggestIA: false,
      showModalCancelSuggestIA: false,
      
      // Api requests
      peticionesAPIAcciones: [],
      showModalOrgProvince: false,
      actualActionAPIRequest: null,

      // All
      showModalWhiteMail: false,
      auxGroupsMail: null,
      showModalLinkMyGroups: false,
      showModalDownloadZip: false,
      estadosPorAccion: [],
      estadosDescargaDesconocido: TIPOS_ESTADOS_DESCARGA_DOWNLOADED,
      loader: false,
      spanish: true,
      nextStatus: null,
      header: {
        title: i18n.t('app.notifications'),
        icon: 'notification',
        breadcrumb: null,
        url: null
      },
      vuexnamespace: 'notifications',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      data: null,
      selected: [],
      listaAcciones: [
        { IdAccion: 102, Descripcion: i18n.t('groups.reasig') },
        { IdAccion: 100, Descripcion: i18n.t('groups.link') },
      ],
      listaAccionesComunes: [
        { IdAccion: 101, Descripcion: i18n.t('groups.unlink') },
        { IdAccion: 200, Descripcion: i18n.t('notificationFilter.update_mail_error') },
        { IdAccion: 201, Descripcion: i18n.t('notificationFilter.update_peticion_api_error') },
        { IdAccion: 202, Descripcion: i18n.t('notificationFilter.resend_mail_error') },
        { IdAccion: 401, Descripcion: i18n.t('app.add_metadata') },
        { IdAccion: 500, Descripcion: i18n.t('app.user_responsable_reasign') },
        { IdAccion: 501, Descripcion: i18n.t('app.user_responsable_unlink') },
        { IdAccion: 600, Descripcion: i18n.t('aiassist.accept_all') },
        { IdAccion: 601, Descripcion: i18n.t('aiassist.cancelar_all') },
        // { IdAccion: 602, Descripcion: i18n.t('aiassist.send_ai') },
        { IdAccion: 603, Descripcion: i18n.t('aiassist.resend_ai') },
        { IdAccion: 700, Descripcion: i18n.t('notificationFilter.delete_reincidencia_errores') },
      ],
      status: null,
      showModal: false,
      showModalArchivar: false,
      showModalDelete: false,
      showModalApplyRules: false,
      showModalTramitar: false,
      showModalOrganismo: false,
      showModalRechazo: false,
      processMessage: this.$i18n.t('app.confirm_download_neo'),
      processMessageArchivar: '¿Estás seguro que deseas archivar las notificaciones seleccionadas sin haberlas descargado previamente?',
      processMessageTramitar: '¿Estás seguro que deseas pasar a tramitadas las notificaciones seleccionadas?',
      processMessageDelete: '¿Estás seguro que deseas borrar las notificaciones seleccionadas?',
      processMessageApplyRules: this.$i18n.t('rules.apply_dialog_text'),
      processMessageUnlinkGroups: '¿Estás seguro que deseas desvincular todos las grupos a las notificaciones seleccionadas?',
      processMessageUnlinkUserResponsable: this.$i18n.t('app.user_responsable_unlink_msg'),
      processMessageAcceptSuggestIA: this.$i18n.t('aiassist.accept_all_confirm'),
      processMessageCancelSuggestIA: this.$i18n.t('aiassist.cancelar_all_confirm'),
      selectedAction: null,
      notificationActions: null,
      isNotice: false,
      noticeType: '',
      isAllCompaniesExcludeOrganismo: false,
    }
  },
  computed: {
    hasModuleAsistenciaIA () {
      return this.$store.getters['auth/hasModuleAsistenciaIA'] 
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    hasModuleColumnasDinamicas () {
      return this.$store.getters['auth/hasModuleColumnasDinamicas']
    },
    hasModuleImportaciones () {
      return this.$store.getters['auth/hasModuleImportaciones']
    },
    hasModuleAsignacionEmailReglas () {
      return this.$store.getters['auth/hasModuleAsignacionEmailReglas']
    },
    hasPermRenombradoFicherosZIP () {
      return this.$store.getters['auth/hasModuleRenombradoFicherosZIP']
    },
    listaGroupsGrouping () {
      if (!this.isEmptyList) {
        const options = []
        this.listaGroups.forEach(x => {
          if (options.filter(y => y.label === x.group).length === 0) {
            options.push(
              { label: x.group, options: [] }
            )
          }
        })
        this.listaGroups.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.group)
          options[index].options.push(
            {
              value: x.id,
              label: x.value,
            }
          )
        })
        return options
      }
      return []
    },
    groupsForAccessibleSelect () {
      return this.listaGroupsGrouping.map(group => ({
        label: group.label,
        options: group.options.map(option => ({
          id: option.value,
          name: option.label,
          value: option.value
        }))
      }))
    },
    usersForAccessibleSelect () {
      return this.listaUsers.map(user => ({
        id: user.IdUsuario,
        name: user.Usuario,
        value: user.IdUsuario
      }))
    },
    titleHeader () {
      switch (this.status) {
        case -3:
          return this.$i18n.t('app.notifications_error_temp')
        case -2:
          return this.$i18n.t('app.notifications_exp')
        case -1:
          return this.$i18n.t('app.notifications_error')
        case 0:
          return this.$i18n.t('app.notifications_pad')
        case 1:
          return this.$i18n.t('app.notifications_od')
        case 2:
          return this.$i18n.t('app.notifications_desc')
        case 3:
          return this.$i18n.t('app.notifications_ed')
        case 4:
          return this.$i18n.t('app.notifications_pfh')
        case 6:
          return this.$i18n.t('app.notifications_noddesc')
        case 7:
          return this.$i18n.t('app.notifications_tramit')
        case 9:
          return this.$i18n.t('app.notifications_ullamada')
        case 10:
          return this.$i18n.t('app.notifications_tra_urg')
        case 11:
          return this.$i18n.t('app.notifications_reabiertas')
        case 13:
          return this.$i18n.t('app.notifications_desc_ext')
        case 14:
          return this.$i18n.t('app.notifications_exp_arch')
        case 15:
          return this.$i18n.t('app.notifications_no_desc_arch')
        case 16:
          return this.$i18n.t('app.notifications_arch_sin_desc')
        case 17:
          return this.$i18n.t('app.notifications_esp_horario')
        case 18:
          return this.$i18n.t('app.notifications_tramit_exp')
        case 19:
          return this.$i18n.t('app.notifications_no_desc_trans')
        case 20:
          return this.$i18n.t('app.notifications_desc_trans')
        case 21:
          return this.$i18n.t('app.notifications_rech')
        case 22:
          return this.$i18n.t('app.notifications_urg_acept')
        case 23:
          return this.$i18n.t('app.notifications_no_atendida')
        case 24:
          return this.$i18n.t('app.notifications_pendiente_acept')
        case 25:
          return this.$i18n.t('app.notifications_rech_urgente')
        default:
          return this.$i18n.t('app.notifications')
      }
    },
    processMessageOrganismo () {
      let message = ''
      if (this.selected !== null && this.selected.length === 1) {
        const neoSelected = this.selected[0]
        const empresasMsg = !this.isAllCompaniesExcludeOrganismo ? `para la empresa <b>${neoSelected.CIF} – ${neoSelected.NombreCIF}</b>` : 'para <b> todas las empresas existentes </b>'
        message = `Está a punto de <b>excluir de EdasNEO</b> la revisión y descarga de notificaciones electrónicas del <b>organismo ${neoSelected.Organismo}</b>, a través de la sede <b>${neoSelected.Sede.Sede}</b> ${empresasMsg}.
        <br/><br/>
        Esta acción le impedirá detectar y descargar cualquier notificación ${empresasMsg}, que provenga de dicho organismo a través de la sede <b>${neoSelected.Sede.Sede}</b> en el futuro.
        <br/><br/>
        ¿Desea aun así, confirmar la <b>acción de excluir</b> el organismo?`
      }
      return DOMPurify.sanitize(message)
    },
    processMessageVincularReparto () {
      return DOMPurify.sanitize(this.$i18n.t('groups.link_reparto_info'))
    },
    processMessageVincularRepartoActive () {
      return this.listaGroups && this.listaGroups.filter(x => this.listaGroupsSelected.includes(x.id)).filter(x => x.idTipo === 3).length > 0
    },
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    heightContainerSelect: function () {
      if (this.heightSelect !== undefined && this.heightSelect !== 0) {
        let heightCalc = this.heightSelect + this.heightInput + 30
        if (heightCalc > 400) heightCalc = 400
        return heightCalc + 'px'
      } else {
        return 'auto'
      }
    },
    isSelectDropdownOpen () {
      return dropdownState.isAnyDropdownOpen
    },
    isEmptyList: function () {
      return this.listaGroups === undefined || this.listaGroups === null || this.listaGroups.length === 0
    },
    isLoadingSelect: function () {
      return this.loadingActionUnSelect || this.loadingActionSelect
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasModuleOrgProvinces () {
      return this.$store.getters['auth/hasModuleOrgProvinces']
    },
    hasModuleAPIRequests () {
      return this.$store.getters['auth/hasModuleAPIRequests']
    },
    peticionesAPIAccionesFilter () {
      if (!this.hasSelected || 
        !this.hasModuleAPIRequests || 
        this.role === 'UsuarioCosulta' ||
        (!this.userHasAllPermActions && !this.hasAllPropietariosByGroups(this.selected))
      ) { 
        return [] 
      }
      const idEmpresa = this.selected[0].Empresa.Id
      const res = []
      if (this.selected.length === this.selected.filter(x => x.Empresa.Id === idEmpresa).length) {
        if (this.selected.length > 0) {
          this.peticionesAPIAcciones.forEach(peticionAPI => {
            if (this.selected.length === this.selected.filter(x => peticionAPI.idEstadosIniciales.includes(x.Estado.Id)).length) {
              res.push(peticionAPI)
            }
          })
        }
      }
      return res
    },
    hasModuleExclusionOrganismos () {
      return this.$store.getters['auth/hasModuleExclusionOrganismos']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 'Usuario' || this.role === 'UsuarioConsulta'
    },
    isAllSelected: function () {
      if (this.listaGroups.length === this.listaGroupsSelected.length) return true
      else return false
    },
    isMoreActionsVisible: function () {
      // return this.notificationActions && this.notificationActions.Acciones.length > 0
      return this.accionesGeneral !== undefined && this.accionesGeneral.length > 0
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.kendo.dataResult ? this.kendo.dataResult.data.length : 0
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    areAllSelected () {
      return this.data.length === this.selected.length
    },
    hasSelected () {
      return this.selected.length > 0
    },
    selectIcon: function () {
      return (IdAccion) =>
        IdAccion === 3 ? 'trash' // Auto
          : IdAccion === 100 ? 'groupadd' // Manual
            : IdAccion === 101 ? 'groupremove' // Manual
              : IdAccion === 200 ? 'mailforbid' // Manual
                : IdAccion === 201 ? 'sendcancel' // Manual
                  : IdAccion === 202 ? 'mailsend' // Manual
                    : IdAccion === 102 ? 'groupchange' // Manual 
                      : IdAccion === 500 ? 'userchange' // Manual 
                        : IdAccion === 501 ? 'userremove' // Manual 
                          : IdAccion === 600 ? 'suggestaccept' // Manual 
                            : IdAccion === 601 ? 'suggestcancel' // Manual 
                              : IdAccion === 22 ? 'suggestaccept' // Manual y Auto
                                : IdAccion === 603 ? 'suggestaccept' // Manual 
                                  : IdAccion === 700 ? 'belloff' // Manual 
                                    : IdAccion === 401 ? 'metadataadd' // Manual 
                                      : IdAccion === 8 ? 'download' // Auto
                                        : IdAccion === 300 ? 'exclude-agencies' // Todos
                                          : IdAccion === 21 ? 'automation' // Auto
                                            : IdAccion === 9 || IdAccion === 16 ? 'mailsend' // Auto
                                              : IdAccion === 19 || IdAccion === 20 ? 'mailsend' // Auto
                                                : 'changestatus' // Auto
    },
    idClienteSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
        const idEmpresa = this.selected[0].Empresa.Id
        if (this.selected.length === this.selected.filter(x => x.Empresa.Id === idEmpresa).length) {
          return idEmpresa
        }
      }
      return -1
    },
    firstNEOSelected () {
      if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) return this.selected[0].IDInterno
      return 0
    },
    prevRoutePath () { return this.prevRoute ? this.prevRoute.path : '/' },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isNotificationsGeneral: function () {
      return (this.status === undefined || this.status === 99999) && (this.noticeType === '' || this.noticeType === undefined)
    },
    accionesBySelected: function () {
      const objAcciones = { Acciones: [] }
      if (this.selected.length > 0) {
        this.estadosPorAccion.forEach(estadoPorAccion => {
          if (this.selected.length === this.selected.filter(x => estadoPorAccion.estados.includes(x.Estado.Id)).length) {
            objAcciones.Acciones.push({ Descripcion: estadoPorAccion.Descripcion, IdAccion: estadoPorAccion.IdAccion })
          }
        })
      }
      return objAcciones
    },
    userGroups () {
      return this.$store.getters['auth/user']?.Grupos
    },
    userHasPoolGroup () {
      return this.userGroups
        ?.some(x => x.idTipo === 1)
    },
    userHasAllPermActions () {
      return this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador' || this.userHasPoolGroup
    },
    accionesGeneral: function () {
      let acciones = []
      if (this.role !== 'UsuarioConsulta') {
        // if (this.userHasAllPermActions) {
        if (this.userHasAllPermActions || this.hasAllPropietariosByGroups(this.selected)) {
          if (this.selected !== undefined && this.selected !== null && this.selected.length > 0) {
            const idEmpresa = this.selected[0].Empresa.Id

            // Acciones relacionadas a grupos

            // Acciones para mismo cliente
            if (this.selected.length === this.selected.filter(x => x.Empresa.Id === idEmpresa).length) {
              if (this.selected.filter(x => x.Estado?.Id === 7).length === 0) {
                acciones = this.listaAcciones
              }
            }

            if (this.role !== 'Usuario' && this.selected.filter(x => x.Estado?.Id === 7).length === 0) {
              // Acciones para todo
              acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 101))
            }
            const firstIdGrupoProp = this.selected[0].idGrupoPropietario
            if (this.selected.length === this.selected.filter(x => x.idGrupoPropietario === firstIdGrupoProp).length) {
              acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 500))
            }
            if (this.selected.length === this.selected.filter(x => x.Empresa.Id === idEmpresa).length) {
              acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 501))
            }
            // Acciones sugerencias de IA
            if (this.hasModuleAsistenciaIA) {
              if (this.selected.length === this.selected.filter(x => x.TieneSugerencias).length) {
                acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 600))
                acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 601))
              }
            }
            if (this.role === 'SuperAdministrador') {
              if (this.selected.length === this.selected.filter(x => x.idEstadoSugerencia !== 5).length) {
                acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 22))
              }
              if (this.selected.length === this.selected.filter(x => x.idEstadoSugerencia === 5).length) {
                acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 603))
              }
            }
            // Accion de quitar alerta de error reincidente
            if (this.selected.length === this.selected.filter(x => x.ReincidenciaErrores).length) {
              acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 700))
            }

            // Acciones para errores
            if (this.selected.filter(x => x.EnviarEmailError).length === this.selected.length) {
              if (!this.isRoleUserOrConsulta) {
                acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 202))
              }
              acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 200))
            }
            if (this.selected.filter(x => x.EnviarPeticionError).length === this.selected.length) {
              acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 201))
            }
            if (this.selected.length === this.selected.filter(x => x.Empresa.Id === idEmpresa).length) {
              acciones = acciones.concat(this.listaAccionesComunes.filter(x => x.IdAccion === 401))
            }
          }
          // Acciones calculadas por estado 
          if (this.isNotificationsGeneral) {
            if (this.hasModuleAsignacionEmailReglas) {
              acciones = acciones.concat(this.accionesBySelected.Acciones)
            } else {
              acciones = acciones.concat(this.accionesBySelected.Acciones.filter(x => x.IdAccion !== 16 && x.IdAccion !== 20))
            }
          } else {
            // Acciones calculadas por estado 
            if (this.notificationActions !== null && this.notificationActions !== undefined) {
              if (this.hasModuleAsignacionEmailReglas) {
                acciones = acciones.concat(this.notificationActions.Acciones)
              } else {
                acciones = acciones.concat(this.notificationActions.Acciones.filter(x => x.IdAccion !== 16 && x.IdAccion !== 20))
              }
            }
          }
          // Quitamos reasignar para los estados de pendiente de aprobación
          if (this.selected.filter(x => [22, 23, 24].includes(x.Estado.Id)).length > 0) {
            acciones = acciones.filter(x => x.IdAccion !== 102)
          }
          // Quitamos enviar email a correos vinculados en caso de que alguna no tengan emails asignados
          if (this.selected.length !== this.selected.filter(x => x.TieneDestinatarioAutomatico).length) {
            acciones = acciones.filter(x => x.IdAccion !== 16 && x.IdAccion !== 20)
          }
        } else {
          // Excepción de reenvio de neo descargada por email (Única acción relacionada a estados, si no eres propietario)
          // Acciones calculadas por estado 
          if (this.isNotificationsGeneral) {
            if (this.hasModuleAsignacionEmailReglas && this.selected.length === this.selected.filter(x => x.TieneDestinatarioAutomatico).length) {
              acciones = this.accionesBySelected.Acciones.filter(x => x.IdAccion === 9 || x.IdAccion === 16 || x.IdAccion === 19 || x.IdAccion === 20 || x.IdAccion === 8)
            } else {
              acciones = this.accionesBySelected.Acciones.filter(x => x.IdAccion === 9 || x.IdAccion === 19 || x.IdAccion === 8)
            }
          } else {
            // Acciones calculadas por estado 
            if (this.notificationActions !== null && this.notificationActions !== undefined) {
              if (this.hasModuleAsignacionEmailReglas && this.selected.length === this.selected.filter(x => x.TieneDestinatarioAutomatico).length) {
                acciones = this.notificationActions.Acciones.filter(x => x.IdAccion === 9 || x.IdAccion === 16 || x.IdAccion === 19 || x.IdAccion === 20 || x.IdAccion === 8)
              } else {
                acciones = this.notificationActions.Acciones.filter(x => x.IdAccion === 9 || x.IdAccion === 19 || x.IdAccion === 8)
              }
            }
          }
        }
        // Quitamos si no tiene modulo de flujo y no es un rol alto quitamos todas las acciones de ese modulo
        if (!this.hasModuleFlujoAceptacion && this.role !== 'SuperAdministrador' && this.role !== 'SuperAdminDistribuidor') {
          acciones = acciones.filter(x => x.IdAccion !== 17 && x.IdAccion !== 18 && x.IdAccion !== 19 && x.IdAccion !== 20)
        }
      }
      
      if (this.role !== 'SuperAdministrador') {
        acciones = acciones.filter(x => x.IdAccion !== 22)
      }

      // Eliminamos borrar y aplicar reglas para rol Usuario
      if (this.isRoleUserOrConsulta) acciones = acciones.filter(x => x.IdAccion !== 3)
      if (this.role !== 'SuperAdministrador') acciones = acciones.filter(x => x.IdAccion !== 21)

      // Accion exclusión de organismo de la notificación con su sede y empresa asociada
      if (!this.isRoleUserOrConsulta && this.selected.length === 1 && this.hasModuleExclusionOrganismos) {
        acciones.push({ Descripcion: 'Excluir organismo asociado', IdAccion: 300 })
      } 

      return acciones
    },
    hasModuleCustomMails () {
      return this.$store.getters['auth/hasModuleCustomMails']
    }, 
    hasModuleFlujoAceptacion () {
      return this.$store.getters['auth/hasModuleFlujoAceptacion']
    }, 
    filterContainsClient () {
      return this.$store.getters[this.vuexnamespace + '/getAppliedFilters']?.empresa
    },
  },
  watch: {
    // $route: 'routerChangeHandler',
    $route (to, from) {
      if (this.$route.params.data) {
        this.filterByParamsData()
      }
      this.controlHeaders()
      this.checkIsNotice(to, from)
      this.updateOnRouteChange(to, from)
      this.routerChangeHandler()
    },
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = processKendo(val, dataState)
      this.unselect()
      // [TMP FIX] recargar data (Deja tiempo suficiente para esperar a getestadosdescarga)
      setTimeout(() => {
        this.routerChangeHandler()
      }, 1000)
    },
    showModalLinkGroupsReasig: async function (val, oldVal) {
      this.loadGroupsSimple(val, true)
    },
    showModalLinkGroups: async function (val, oldVal) {
      this.loadGroupsSimple(val)
    },
    showUserResponsable: async function (val, oldVal) {
      this.loadUsersSimple(val)
    },
    // actionsForSelect: function (val, oldVal) {
    //   if (val !== undefined && val !== null && val !== oldVal) {
    //     this.resetNotificationActions()
    //   }
    // }
  },
  // beforeRouteUpdate: async function (to, from, next) {
  //   this.updateOnRouteChange(to, from)
  //   next()
  // },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  created: async function () {
    // console.log('filtersede', this.$route)

    // Actualizamos para obtener grupos actualizados
    this.$store.dispatch('auth/me', false)

    this.status = this.$route.meta.status
    this.controlHeaders()
    this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)

    if (this.$route.params.data) {
      this.filterByParamsData()
    } else {
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
    }

    if (this.$route.meta && this.$route.meta.notice !== undefined && this.$route.meta.notice !== null) {
      this.isNotice = true
      this.noticeType = this.$route.meta.notice
      if (this.noticeType === 'error') {
        this.header.title = i18n.t('app.noticesError')
      } else if (this.noticeType === 'finTramite') {
        this.header.title = i18n.t('app.noticesFinTramite')
      } else if (this.noticeType === 'sinDescarga') {
        this.header.title = i18n.t('app.noticesSinDescarga')
      } else {
        console.error('NoticeType no encontrado o no registrado')
      }
    } else {
      this.isNotice = false
      this.noticeType = ''
      this.header.title = this.titleHeader
    }
    // this.kendo = this.$store.getters[this.vuexnamespace + '/getKendo']
  },
  mounted: async function () {
    this.status = parseInt(this.$store.getters[this.vuexnamespace + '/getMenuType'])
    // if (!this.prevRoutePath.includes('notifications')) {
    //   this.$store.commit(this.vuexnamespace + '/resetPaginationInfo')
    // }
    // this.controlHeaders()
    // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
    this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)

    if (this.status !== undefined && this.status !== 99999) {
      this.downloadNotificationDataByStatus(this.status)
    } else {
      // if (to.meta && to.meta.notice !== undefined) {
      //   this.isNotice = true
      //   this.noticeType = to.meta.notice
      // }
      this.data = await this.applyFilters()
    }
    await this.$store.dispatch('app/getNotificationsTypes')
  },
  methods: {
    handleOpenModalDialog (refName) {
      this.handleOpenModalDialogMixin(refName)
    },
    releaseFocusDialog () {
      this.releaseFocusDialogMixin()
    },
    toggleModalOrgProvince () {
      this.showModalOrgProvince = !this.showModalOrgProvince
    },
    showActionModal: function (action) {
      this.actualActionAPIRequest = action
      if (action.OrganismoProvinciaRequerido && this.selected.filter(x => !x.TieneOrganismoProvincia).length > 0 && this.hasModuleOrgProvinces) {
        this.toggleModalOrgProvince()
      } else {
        this.sendPetitionAPIHandler()
      }
    },
    updateGetPeticionesApiAcciones () {
      if (((this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') && this.filterContainsClient) ||
        ((this.role === 'Administrador' || this.role === 'Usuario') && this.hasModuleAPIRequests)) {
        this.getPeticionesAPIAcciones()
      } 
    },
    getPeticionesAPIAcciones: async function () {
      try {
        this.peticionesAPIAcciones = []
        this.$store.commit('setIsLoading', true)
        let payload = {}
        if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
          payload = { NombreCliente: this.filterContainsClient?.value }
        }
        const response = await getPeticionesAPIAcciones(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.peticionesAPIAcciones = response.respuesta
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    sendUpdateOrgProvinceAndPetitionAPI: async function (form) {
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          AsociarOrganismoNEO: form.switch,
          idOrganismoProvincia: form.value, 
          idNEOs: this.selected.map(x => x.IDInterno)
        }
        const response = await updateOrganismoProvinciaNEOs(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.showModalOrgProvince = false
          this.sendPetitionAPIHandler()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
      }
    },
    sendPetitionAPIHandler: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          idPeticion: this.actualActionAPIRequest.idPeticion, 
          idNEOs: this.selected.map(x => x.IDInterno)
        }
        const response = await ejecutarPeticionApi(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.showModalOrgProvince = false
          this.doFeedback('Enviado correctamente', 'success')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleDialogMetadato: function () {
      this.showNewMetadato = !this.showNewMetadato
    },
    applyDialogMetadatoHandler: async function (form) {
      this.$store.commit('setIsLoading', true)
      try {
        const payload = {
          Campo: form.Campo, 
          Valor: form.Valor,
          idNeos: this.selected.map(x => x.IDInterno)
        }

        const response = await addMetadatoMasivo(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleDialogMetadato()
          this.doFeedback('Metadato añadido correctamente', 'success')
          this.data = await this.applyFilters()
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    loadUsersSimple: async function (val) {
      this.isLoadedData = false
      try {
        if (val) {
          const data = await getUsuariosByGrupo({ idGrupo: this.selected[0].idGrupoPropietario })
          if (data.blnError) {
            this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
          } else {
            this.listaUsers = data.respuesta
          }
        } else {
          this.listaUsers = []
          this.userResponsableSelected = null
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
    toggleDialogUserResponsable () {
      this.showUserResponsable = !this.showUserResponsable
    },
    hasAllPropietariosByGroups (neos) {
      return neos
        .every(x => this.userGroups
          ?.some(y => y.idGrupo === x.GrupoPropietario.idGrupo))
    },
    loadGroupsSimple: async function (val, withoutReparto = false) {
      this.isLoadedData = false
      try {
        if (val === true) {
          const data = await getGroupsSimple({ idNEO: this.firstNEOSelected })
          if (data.blnError === true) {
            this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
          } else {
            data.Respuesta.forEach(row => {
              if (withoutReparto) {
                if (row.idTipo === 1 || row.idTipo === 2) {
                  this.listaGroups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo, idTipo: row.idTipo })
                }
              } else {
                this.listaGroups.push({ id: row.IdGrupo, value: row.Nombre, group: row.Tipo, idTipo: row.idTipo })
              }
            })
          }
        } else {
          this.listaGroups = []
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.isLoadedData = true
      }
    },
    generateEstadosPorAccion: function () {
      const estadosPorAccion = []
      this.notificationActions.forEach(estadoAccion => {
        estadoAccion.Acciones.forEach(accion => {
          if (estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion).length === 0) {
            const accionTMP = accion
            accionTMP.estados = []
            estadosPorAccion.push(accionTMP)
          }
          if (!estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.includes(estadoAccion.idEstado)) {
            estadosPorAccion.filter(x => x.IdAccion === accion.IdAccion)[0].estados.push(estadoAccion.idEstado)
          }
        })
      })
      // console.log(estadosPorAccion)
      this.estadosPorAccion = estadosPorAccion
    },
    toggleImportNeos () {
      this.showModalImportNeos = !this.showModalImportNeos
    },
    toggleTextoCorreo () {
      this.showModalTextoCorreo = !this.showModalTextoCorreo
    },
    toggleImportNeosPaD () {
      this.showModalImportNeosPaD = !this.showModalImportNeosPaD
    },
    filesToPayloadXML: async function (files) {
      const xmls = []
      const listPromises = []
      // Ejemplo promesas multiples asincronas con espera final de todas
      files.forEach((file) => {
        listPromises.push(this.getBase64(file.raw)
          .then(res => {
            const b64 = res.split(',')[1]
            xmls.push({
              Base64: b64,
              Nombre: file.name
            })
          }))
      })
      await Promise.all(listPromises)
      return xmls
    },
    applyImportNeos: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const xmls = await this.filesToPayloadXML(files)
        const payload = {
          idCliente: form.idCliente,
          AplicarReglas: form.switch1,
          Notificaciones: xmls,
        }

        const response = await importNeos(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportNeos() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyImportNeosPaD: async function (files, form) {
      this.$store.commit('setIsLoading', true)
      try {
        const xmls = await this.filesToPayloadXML(files)
        const payload = {
          idCliente: form.idCliente,
          Notificaciones: xmls[0],
        }

        const response = await importNeosPaD(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportNeosPaD() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateNeos: async function () { 
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateNeos()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'importacion-neos-desc-xsd-ejemplos.zip')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateNeosPaD: async function () { 
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateNeosPaD()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'importacion-neos-pad-xsd-ejemplos.zip')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    onExpand (value) {
      this.onChangeInput()
      if (value) {
        setTimeout(() => {
          const elementsScrollBar = document.getElementsByClassName('el-scrollbar')
          this.heightSelect = elementsScrollBar[elementsScrollBar.length - 1]?.clientHeight
        }, 100)
      } else {
        this.heightSelect = 0
      }
    },
    onChangeInput () {
      setTimeout(() => {
        this.heightInput = this.$refs.selectRefAgencies?.clientHeight ?? 35
      }, 100)
    },
    applyLinkHandler: async function (tags) {
      this.showModalLinkGroups = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupos: [], idNEOs: [] }
        payload.idGrupos = this.listaGroupsSelected
        payload.idNEOs = this.selected.map(x => x.IDInterno)
        const response = await linkNEOGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Vinculado correctamente', 'success')
        }
        this.listaGroupsSelected = []
        this.data = await this.applyFilters()
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyLinkReasignHandler: async function () {
      this.showModalLinkGroupsReasig = false
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idGrupo: this.groupReasignSelected, idNotificaciones: [], mantenerGrupo: this.mantenerGrupo }
        payload.idNotificaciones = this.selected.map(x => x.IDInterno)
        const response = await linkNEOsGroupReasign(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Reasignado correctamente', 'success')
        }
        this.groupReasignSelected = null
        this.mantenerGrupo = false
        this.data = await this.applyFilters()
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    applyUserResponsableReasignHandler: async function () {
      if (!this.userResponsableSelected) {
        this.doFeedback('Debe seleccionar un usuario responsable')
        return
      }
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idUsuario: this.userResponsableSelected, idNotificaciones: [] }
        payload.idNotificaciones = this.selected.map(x => x.IDInterno)
        const response = await asignarusuarioresponsableneos(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Reasignado correctamente', 'success')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.showUserResponsable = false
        this.userResponsableSelected = null
        this.data = await this.applyFilters()
        this.$store.commit('setIsLoading', false)
      }
    },
    linkMyGroupsToggleDialog () {
      this.showModalLinkMyGroups = !this.showModalLinkMyGroups
    },
    toggleDialogs: function () {
      if (this.showModalLinkGroups && this.isLoadingSelect) return
      this.listaGroupsSelected = []
      this.showModalLinkGroups = !this.showModalLinkGroups
    },
    toggleDialogReasign () {
      if (this.showModalLinkGroupsReasig && this.isLoadingSelect) return
      this.groupReasignSelected = null
      this.mantenerGrupo = false
      this.showModalLinkGroupsReasig = !this.showModalLinkGroupsReasig
    },
    handleSelectAll: async function () {
      await this.handleUnSelectAll()
      this.loadingActionSelect = true
      this.listaGroups.forEach(element => {
        setTimeout(() => {
          this.listaGroupsSelected.push(element.id)
          if (this.listaGroupsSelected.length === this.listaGroups.length) {
            this.loadingActionSelect = false
            this.loadingActionUnSelect = false
          }
        }, 100)
      })
    },
    handleUnSelectAll: async function () {
      this.loadingActionUnSelect = true
      const staticLength = this.listaGroupsSelected.length
      for (let index = 0; index < staticLength; index++) {
        setTimeout(() => {
          this.listaGroupsSelected.pop()
          if (this.listaGroupsSelected.length === 0) this.loadingActionUnSelect = false
        }, 100)
      }
    },
    controlHeaders: function () {
      // Deshabilitado temporalmente (problemas con almacenamiento persistente en store al estar compartiendo store con todas las vistas)

      // const status = this.$route.meta.status
      // const noticeType = this.$route.meta.notice
      // if (status === -3 || status === '-3' || noticeType === 'error') {
      // // if (status === 6 || status === '6') {
      //   this.kendo.columns.forEach(columna => {
      //     if (columna.field === 'UltimoError') {
      //       if (columna.hidden) {
      //         columna.hidden = false
      //       }
      //     }
      //   })
      // } else {
      //   this.$store.commit(this.vuexnamespace + '/resetColumnOrderDefault')
      //   this.kendo.columns.forEach(columna => {
      //     if (columna.field === 'UltimoError') {
      //       if (columna.hidden === undefined || columna.hidden == null || columna.hidden === false) {
      //         columna.hidden = true
      //       }
      //     }
      //   })
      // }
    },
    updateAllSelectedHeader: function () {
      if (!this.hasSelected) {
        this.kendo.columns[0].headerSelectionValue = false
      } else {
        this.kendo.columns[0].headerSelectionValue = this.areAllSelected
      }
    },
    preserveEmpresaFilter (filters) {
      const applied = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      if (applied.empresa) {
        filters.empresa = { label: applied.empresa.label, value: applied.empresa.value }
      }
    },
    filterByParamsData: function () {
      const data = this.$route.params.data
      const filters = {}
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'sede') {
            const codPGN = { label: 'Sede', value: filter.data.codigo }
            filters.codPGN = codPGN
          } else if (filter.type === 'archivadas') {
            const archivadas = { label: this.$i18n.t('notificationFilter.archivadas'), value: filter.data?.id }
            filters.archivadas = archivadas
          } else if (filter.type === 'company') {
            const cif = { label: 'Razón social', value: filter.data.label }
            filters.NombreCIF = cif
          } else if (filter.type === 'cliente') {
            const cliente = { label: 'Cliente', value: filter.data.label }
            filters.empresa = cliente
          } else if (filter.type === 'notificacionesEmailError') {
            this.preserveEmpresaFilter(filters)

            const EnviarEmailError = { label: this.$i18n.t('notificationFilter.eviar_email_error'), value: filter.data }
            filters.EnviarEmailError = EnviarEmailError
          } else if (filter.type === 'notificacionesPresentacionesError') {
            this.preserveEmpresaFilter(filters)

            const tipoPresentacionEstado = { label: this.$i18n.t('presentations.Estado_NEO'), value: filter.data }
            filters.tipoPresentacionEstado = tipoPresentacionEstado
          } else if (filter.type === 'notificacionesPeticionError') {
            this.preserveEmpresaFilter(filters)

            const enviarPeticionError = { label: this.$i18n.t('notificationFilter.notificacionesPeticionError'), value: filter.data }
            filters.enviarPeticionError = enviarPeticionError
          } else if (filter.type === 'sugerenciasPendientes') {
            this.preserveEmpresaFilter(filters)

            const idEstadoSugerencia = { label: this.$i18n.t('app.status_suggested'), value: filter.data }
            filters.idEstadoSugerencia = idEstadoSugerencia
          } else if (filter.type === 'reincidenciaErrores') {
            this.preserveEmpresaFilter(filters)

            const reincidenciaErrores = { label: this.$i18n.t('notificationFilter.ReincidenciaErrores'), value: filter.data }
            filters.reincidenciaErrores = reincidenciaErrores
          }
        })
        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filters)
      }
    },
    checkIsNotice: function (to, from) {
      this.status = parseInt(to.meta.status)
      if (to.meta && to.meta.notice !== undefined) {
        this.isNotice = true
        this.noticeType = to.meta.notice
        if (this.noticeType === 'error') {
          this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
          this.header.title = i18n.t('app.noticesError')
        } else if (this.noticeType === 'finTramite') {
          this.header.title = i18n.t('app.noticesFinTramite')
        } else if (this.noticeType === 'sinDescarga') {
          this.header.title = i18n.t('app.noticesSinDescarga')
        } else {
          console.error('NoticeType no encontrado o no registrado')
        }
      } else {
        this.isNotice = false
        this.noticeType = ''
        this.header.title = this.titleHeader
      }
    },
    updateOnRouteChange: async function (to, from) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setMenuType', this.status)
      // this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      // this.$store.commit(this.vuexnamespace + '/resetPaginationInfo')
      if (to.meta && to.meta.status !== undefined && to.meta.status !== 99999) {
        this.downloadNotificationDataByStatus(this.status)
      } else {
        this.data = await this.applyFilters()
      }
    },
    routerChangeHandler: function (to, from) {
      this.resetNotificationActions()
      if (this.status !== undefined && this.status !== 99999) {
        this.notificationActions = this.$store.getters['app/actionsForSelect'](this.status)
      } else {
        this.resetNotificationActions()
      }
    },
    resetNotificationActions: function () {
      if (this.noticeType === 'error') {
        this.notificationActions = {
          Acciones: [
            { Descripcion: 'Reintentar descarga', IdAccion: 2 }, 
            { Descripcion: 'Borrar', IdAccion: 3 },
            { Descripcion: 'Pasar a no descargable', IdAccion: 10 },
          ] 
        }
      } else { // NEOs por tipo o generales
        this.notificationActions = this.$store.getters['app/actionsForSelect']()
        this.generateEstadosPorAccion() // Necesario para logica automatica de compatibilidad de acciones
      }
    },
    openPath: function (event) {
      // console.log('DATAITEM', event.dataItem)
      this.$store.commit('app/setheaderBreadCrumb', event.dataItem.Asunto)
      const status = this.status === 99999 ? event.dataItem.Estado.Id : this.status
      const backGeneral = (this.status === undefined || this.status === 99999)

      const filtrosContenido = this.tags.filter(x => x[0] === 'textoLibre')
      let dataFilters = null
      if (filtrosContenido && filtrosContenido.length > 0) {
        dataFilters = { filters: [] }
        dataFilters.filters.push({ type: 'contenido', data: filtrosContenido[0][2] })
      }

      this.$router.push(
        {
          name: 'notification/details', 
          params: { 
            id: event.dataItem.IDInterno, 
            type: status, 
            asunto: event.dataItem.Asunto, 
            notice: this.noticeType, 
            backGeneral,
            data: dataFilters,
          } 
        })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        // dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loader = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idInterno: data.idInterno ? data.idInterno.value : null,
        // estadoDescarga: (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null,
        tipo: data.tipoNotif ? data.tipoNotif.value : null,
        organismo: data.organismo ? data.organismo.value : null,
        asunto: data.asunto ? data.asunto.value : null,
        TicketID: data.ticketId ? data.ticketId.value : null,
        fechaDisposicionDesde: data.fechaDisposicionDesde ? data.fechaDisposicionDesde.value : null,
        fechaDisposicionHasta: data.fechaDisposicionHasta ? data.fechaDisposicionHasta.value : null,
        fechaDescargaDesde: data.fechaDescargaDesde ? data.fechaDescargaDesde.value : null,
        fechaDescargaHasta: data.fechaDescargaHasta ? data.fechaDescargaHasta.value : null,
        fechaFinTramiteDesde: data.fechaFinTramiteDesde ? data.fechaFinTramiteDesde.value : null,
        fechaFinTramiteHasta: data.fechaFinTramiteHasta ? data.fechaFinTramiteHasta.value : null,
        fechaHoraRegistroDesde: data.fechaHoraRegistroDesde ? data.fechaHoraRegistroDesde.value : null,
        fechaHoraRegistroHasta: data.fechaHoraRegistroHasta ? data.fechaHoraRegistroHasta.value : null,
        // codPGN: data.codPGN ? data.codPGN.value : null,
        CIF: data.cif ? data.cif.value : null, 
        CIFTitular: data.cifTitular ? data.cifTitular.value : null,
        NombreCIF: data.NombreCIF ? data.NombreCIF.value : null,
        textoLibre: data.textoLibre ? data.textoLibre.value : null,
        email: data.email ? data.email.value: null,
        emailEnviado: data.emailEnviado ? data.emailEnviado.value: null,
        ultimoError: data.ultimoError ? data.ultimoError.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        comentarios: data.notas ? data.notas.value : null,
        altaManual: data.altaManual ? data.altaManual.value : null,
        DescargadaAutomaticamente: data.DescargadaAutomaticamente ? data.DescargadaAutomaticamente.value : null,
        enviarEmailError: data.EnviarEmailError ? data.EnviarEmailError.value : null,
        estadoPresentacion: data.tipoPresentacionEstado ? data.tipoPresentacionEstado.value : null,
        tieneDestinatarioAutomatico: data.tieneDestinatarioAutomatico ? data.tieneDestinatarioAutomatico.value : null,
        tieneReglaAplicada: data.tieneReglaAplicada ? data.tieneReglaAplicada.value : null,
        reincidenciaErrores: data.reincidenciaErrores ? data.reincidenciaErrores.value : null,
        soyPropietario: data.soyPropietario ? data.soyPropietario.value : null,
        usuarioResponsable: data.UsuarioResponsable ? data.UsuarioResponsable.value : null,
        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        agrupacionCIF: data.agrupacionCIF ? data.agrupacionCIF.value : null,
        agrupacionSede: data.agrupacionSede ? data.agrupacionSede.value : null,
        agrupacionOrganismo: data.agrupacionOrganismo ? data.agrupacionOrganismo.value : null,
        archivada: data.archivadas ? data.archivadas.value : null,
        CodigoOrganismo: data.CodigoOrganismo ? data.CodigoOrganismo.value : null,
        NombreOrganismo: data.NombreOrganismo ? data.NombreOrganismo.value : null,
        CodigoProvincia: data.CodigoProvincia ? data.CodigoProvincia.value : null,
        NombreProvincia: data.NombreProvincia ? data.NombreProvincia.value : null,

        enviarPeticionError: data.enviarPeticionError ? data.enviarPeticionError.value : null,

        nombreGrupoPropietarioAnterior: data.nombreGrupoPropietarioAnterior ? data.nombreGrupoPropietarioAnterior.value : null,
        TieneGrupoReparto: data.TieneGrupoReparto ? data.TieneGrupoReparto.value : null,
        nombrePeticion: data.nombrePeticion ? data.nombrePeticion.value : null,
        enviadoPeticion: data.enviadoPeticion ? data.enviadoPeticion.value : null,

        idEstadoSugerencia: data.idEstadoSugerencia ? data.idEstadoSugerencia.value : null,
      }
      const orders = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { 
        order: orders.order, 
        grupos: objColumnas,
      }

      // Filtros multiples casos especiales
      const estadosFilter = (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null
      if (Array.isArray(estadosFilter)) {
        payload.estadosDescarga = estadosFilter
      } else {
        params.estadoDescarga = estadosFilter
      }
      const sedesFilter = data.codPGN ? data.codPGN.value : null
      if (Array.isArray(sedesFilter)) {
        payload.codPGNs = sedesFilter
      } else {
        params.codPGN = sedesFilter
      }
      
      // Filtros objetos
      if (data.metadato1 && data.metadato1.value && data.metadato1.value.campo && data.metadato1.value.valor && data.metadato1.value.operador) {
        payload.metadato1 = {
          campo: data.metadato1.value.campo,
          valor: data.metadato1.value.valor,
          operador: data.metadato1.value.operador,
        }
      }
      if (data.metadato2 && data.metadato2.value && data.metadato2.value.campo && data.metadato2.value.valor && data.metadato2.value.operador) {
        payload.metadato2 = {
          campo: data.metadato2.value.campo,
          valor: data.metadato2.value.valor,
          operador: data.metadato2.value.operador,
        }
      }
      if (data.metadato3 && data.metadato3.value && data.metadato3.value.campo && data.metadato3.value.valor && data.metadato3.value.operador) {
        payload.metadato3 = {
          campo: data.metadato3.value.campo,
          valor: data.metadato3.value.valor,
          operador: data.metadato3.value.operador,
        }
      }
      if (data.metadato4 && data.metadato4.value && data.metadato4.value.campo && data.metadato4.value.valor && data.metadato4.value.operador) {
        payload.metadato4 = {
          campo: data.metadato4.value.campo,
          valor: data.metadato4.value.valor,
          operador: data.metadato4.value.operador,
        }
      }
      if (data.metadato5 && data.metadato5.value && data.metadato5.value.campo && data.metadato5.value.valor && data.metadato5.value.operador) {
        payload.metadato5 = {
          campo: data.metadato5.value.campo,
          valor: data.metadato5.value.valor,
          operador: data.metadato5.value.operador,
        }
      }

      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.IDInterno)
        payload.listaIDs = selectedIDs
      }
      let response
      try {
        if (!this.isNotice) {
          response = await downloadExcel(payload, params)
        } else {
          if (this.noticeType === 'error') {
            response = await downloadExcelError(payload, params)
          } else if (this.noticeType === 'finTramite') {
            response = await downloadExcelFinTramite(payload, params)
          } else if (this.noticeType === 'sinDescarga') {
            response = await downloadExcelSinDescargar(payload, params)
          } else {
            response = null
            // throw new Error ('NoticeType no encontrado o no registrado al exportar excel')
          }
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'notificaciones.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loader = false
      }
    },
    toBinary: function (string) {
      const codeUnits = new Uint16Array(string.length)
      for (let i = 0; i < codeUnits.length; i++) {
        codeUnits[i] = string.charCodeAt(i)
      }
      return String.fromCharCode(...new Uint8Array(codeUnits.buffer))
    },
    fromBinary: function (binary) {
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < bytes.length; i++) {
        bytes[i] = binary.charCodeAt(i)
      }
      return String.fromCharCode(...new Uint16Array(bytes.buffer))
    },
    onColumnsSubmit: function (columnsState) {
      const options = {
        columns: columnsState
      }
      this.columnReorder(options)
      // this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    expandchange: function (event) {
      event.dataItem[event.target.$props.expandField] = !event.dataItem[event.target.$props.expandField]
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      this.$store.commit('setIsLoading', true)
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']

      const params = {
        idInterno: data.idInterno ? data.idInterno.value : null,
        // estadoDescarga: (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null,
        tipo: data.tipoNotif ? data.tipoNotif.value : null,
        organismo: data.organismo ? data.organismo.value : null,
        asunto: data.asunto ? data.asunto.value : null,
        TicketID: data.ticketId ? data.ticketId.value : null,
        fechaDisposicionDesde: data.fechaDisposicionDesde ? data.fechaDisposicionDesde.value : null,
        fechaDisposicionHasta: data.fechaDisposicionHasta ? data.fechaDisposicionHasta.value : null,
        fechaDescargaDesde: data.fechaDescargaDesde ? data.fechaDescargaDesde.value : null,
        fechaDescargaHasta: data.fechaDescargaHasta ? data.fechaDescargaHasta.value : null,
        fechaFinTramiteDesde: data.fechaFinTramiteDesde ? data.fechaFinTramiteDesde.value : null,
        fechaFinTramiteHasta: data.fechaFinTramiteHasta ? data.fechaFinTramiteHasta.value : null,
        fechaHoraRegistroDesde: data.fechaHoraRegistroDesde ? data.fechaHoraRegistroDesde.value : null,
        fechaHoraRegistroHasta: data.fechaHoraRegistroHasta ? data.fechaHoraRegistroHasta.value : null,
        // codPGN: data.codPGN ? data.codPGN.value : null,
        CIF: data.cif ? data.cif.value : null, 
        CIFTitular: data.cifTitular ? data.cifTitular.value : null,
        NombreCIF: data.NombreCIF ? data.NombreCIF.value : null,
        textoLibre: data.textoLibre ? data.textoLibre.value : null,
        email: data.email ? data.email.value: null,
        emailEnviado: data.emailEnviado ? data.emailEnviado.value: null,
        ultimoError: data.ultimoError ? data.ultimoError.value : null,
        Distribuidor: data.distribuidor ? data.distribuidor.value : null,
        Empresa: data.empresa ? data.empresa.value : null,
        comentarios: data.notas ? data.notas.value : null,
        altaManual: data.altaManual ? data.altaManual.value : null,
        DescargadaAutomaticamente: data.DescargadaAutomaticamente ? data.DescargadaAutomaticamente.value : null,
        enviarEmailError: data.EnviarEmailError ? data.EnviarEmailError.value : null,
        estadoPresentacion: data.tipoPresentacionEstado ? data.tipoPresentacionEstado.value : null,
        tieneDestinatarioAutomatico: data.tieneDestinatarioAutomatico ? data.tieneDestinatarioAutomatico.value : null,
        tieneReglaAplicada: data.tieneReglaAplicada ? data.tieneReglaAplicada.value : null,
        reincidenciaErrores: data.reincidenciaErrores ? data.reincidenciaErrores.value : null,
        soyPropietario: data.soyPropietario ? data.soyPropietario.value : null,
        usuarioResponsable: data.UsuarioResponsable ? data.UsuarioResponsable.value : null,

        nombreGrupo: data.nombreGrupo ? data.nombreGrupo.value : null,
        nombreGrupoPropietario: data.nombreGrupoPropietario ? data.nombreGrupoPropietario.value : null,
        agrupacionCIF: data.agrupacionCIF ? data.agrupacionCIF.value : null,
        agrupacionSede: data.agrupacionSede ? data.agrupacionSede.value : null,
        agrupacionOrganismo: data.agrupacionOrganismo ? data.agrupacionOrganismo.value : null,
        archivada: data.archivadas ? data.archivadas.value : null,
        CodigoOrganismo: data.CodigoOrganismo ? data.CodigoOrganismo.value : null,
        NombreOrganismo: data.NombreOrganismo ? data.NombreOrganismo.value : null,
        CodigoProvincia: data.CodigoProvincia ? data.CodigoProvincia.value : null,
        NombreProvincia: data.NombreProvincia ? data.NombreProvincia.value : null,
        
        enviarPeticionError: data.enviarPeticionError ? data.enviarPeticionError.value : null,

        nombreGrupoPropietarioAnterior: data.nombreGrupoPropietarioAnterior ? data.nombreGrupoPropietarioAnterior.value : null,
        TieneGrupoReparto: data.TieneGrupoReparto ? data.TieneGrupoReparto.value : null,
        nombrePeticion: data.nombrePeticion ? data.nombrePeticion.value : null,
        enviadoPeticion: data.enviadoPeticion ? data.enviadoPeticion.value : null,
        
        idEstadoSugerencia: data.idEstadoSugerencia ? data.idEstadoSugerencia.value : null,
      }

      const obj = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)

      // Filtros multiples casos especiales
      const estadosFilter = (this.status !== undefined && this.status !== 99999) ? this.status : data.estadoDescargaExtra ? data.estadoDescargaExtra.value : null
      if (Array.isArray(estadosFilter)) {
        obj.estadosDescarga = estadosFilter
      } else {
        params.estadoDescarga = estadosFilter
      }
      const sedesFilter = data.codPGN ? data.codPGN.value : null
      if (Array.isArray(sedesFilter)) {
        obj.codPGNs = sedesFilter
      } else {
        params.codPGN = sedesFilter
      }
      // Filtros objetos
      if (data.metadato1 && data.metadato1.value && data.metadato1.value.campo && data.metadato1.value.valor && data.metadato1.value.operador) {
        obj.metadato1 = {
          campo: data.metadato1.value.campo,
          valor: data.metadato1.value.valor,
          operador: data.metadato1.value.operador,
        }
      }
      if (data.metadato2 && data.metadato2.value && data.metadato2.value.campo && data.metadato2.value.valor && data.metadato2.value.operador) {
        obj.metadato2 = {
          campo: data.metadato2.value.campo,
          valor: data.metadato2.value.valor,
          operador: data.metadato2.value.operador,
        }
      }
      if (data.metadato3 && data.metadato3.value && data.metadato3.value.campo && data.metadato3.value.valor && data.metadato3.value.operador) {
        obj.metadato3 = {
          campo: data.metadato3.value.campo,
          valor: data.metadato3.value.valor,
          operador: data.metadato3.value.operador,
        }
      }
      if (data.metadato4 && data.metadato4.value && data.metadato4.value.campo && data.metadato4.value.valor && data.metadato4.value.operador) {
        obj.metadato4 = {
          campo: data.metadato4.value.campo,
          valor: data.metadato4.value.valor,
          operador: data.metadato4.value.operador,
        }
      }
      if (data.metadato5 && data.metadato5.value && data.metadato5.value.campo && data.metadato5.value.valor && data.metadato5.value.operador) {
        obj.metadato5 = {
          campo: data.metadato5.value.campo,
          valor: data.metadato5.value.valor,
          operador: data.metadato5.value.operador,
        }
      }

      try {
        const data = await this.getItemsData(obj, params)
        if (data) {
          // Cambiar nombre columnas dinamicas
          this.$store.commit('notifications/setkendoColumnsMetadatos', data.metadatosAdicionales)
          // Devolver datos
          return data.data.map(item => {
            item.selected = false
            // item.FechaDisposicion = moment(item.FechaDisposicion).format('DD-MM-yyyy HH:mm')
            const yearFechaDescarga = new Date(item.FechaDescarga).getFullYear()
            item.FechaDescarga = yearFechaDescarga >= 2000 ? item.FechaDescarga : ' - '
            // Formato para fechas dependiendo del tipo de estado
            const tmp = this.estadosDescargaDesconocido
            if (item.FechaDescarga === ' - ' && tmp.includes(item.Estado.Id)) {
              item.FechaDescarga = 'Desconocido'
            }
            const yearFechaFinTramite = new Date(item.FechaFinTramite).getFullYear()
            item.FechaFinTramite = yearFechaFinTramite >= 2000 ? item.FechaFinTramite : ' - '
            return item
          })
        }
      } catch (error) {
        this.doFeedback()
        console.log(error)
      } finally {
        this.updateGetPeticionesApiAcciones() 
        this.$store.commit('setIsLoading', false)
      }
      this.updateAllSelectedHeader()

      return null
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      const data = res.respuesta
      const metadatosAdicionales = {
        metadato1: res.metadatos.Metadato1,
        metadato2: res.metadatos.Metadato2,
        metadato3: res.metadatos.Metadato3,
        metadato4: res.metadatos.Metadato4,
        metadato5: res.metadatos.Metadato5,
      }
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false

      if (pagination.currentPage > pagination.totalPages) {
        this.applyFiltersHandler()
      }
      
      return { data, metadatosAdicionales }
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      let data
      if (!this.isNotice) {
        data = await getNotifications(orders, params)
      } else {
        if (this.noticeType === 'error') {
          data = await getNEOError(orders, params)
        } else if (this.noticeType === 'finTramite') {
          data = await getNEOFinTramite(orders, params)
        } else if (this.noticeType === 'sinDescarga') {
          data = await getNEOSinDescargar(orders, params)
        } else {
          console.error('NoticeType no encontrado o no registrado')
        }
      }
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      // data.respuesta.forEach(o => {
      //   // o.FechaPublicacion = moment(o.FechaPublicacion).format('DD-MM-YYYY HH:mm')
      //   // o.FechaDescargaExterna = moment(o.FechaDescargaExterna).format('DD-MM-YYYY HH:mm')
      // })
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters()
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      try {
        this.data = await this.applyFilters()
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      }
    },
    removeFilterTagHanlder: async function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.data = await this.applyFilters()
    },
    headerCoreFiltersHandler: async function (obs) {
      if (this.isHeadCoreReady) {
        this.data = await this.applyFilters()
      }
    },
    removeAllTagsHandler: async function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.data = await this.applyFilters()
    },
    tableSortByChangeHandler: async function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters()
    },
    unselect: function () {
      const checked = false
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    download: async function () {
      this.showModal = !this.showModal
    },
    deleteNotification: async function () {
      this.showModalDelete = !this.showModalDelete
    },
    toggleTramitar () {
      this.showModalTramitar = !this.showModalTramitar
    },
    downloadHandler: async function () {
      this.executeActionHandler()
    },
    archivarHandler: async function () {
      this.executeActionHandler()
    },
    deleteHandler: async function () {
      this.executeActionHandler()
    },
    tramitarHandler () {
      this.executeActionHandler()
    },
    excluirOrganismo: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        this.loader = true
        const neoSelected = this.selected[0]
        const params = {
          idOrganismo: neoSelected.idOrganismo,
          idPgn: neoSelected.Sede.Id,
          idCifEmpresa: this.isAllCompaniesExcludeOrganismo ? null : neoSelected.idCIFEmpresa,
          idCliente: neoSelected.Empresa.Id,
        }
        const response = await addExclusionOrganismo(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Organismo excluido correctamente', 'success')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.loader = false
      }
    },
    goLinkLocation: function () {
      this.linkLocation = !this.linkLocation
    },
    onHeaderSelectionChange: function (event) {
      const checked = event.event.target.checked
      this.mapSelectionKendoGrouping(checked)
      this.updateAllSelectedHeader()
    },
    onSelectionChange: function (event) {
      event.dataItem[this.selectedField] = !event.dataItem[this.selectedField]
      this.selected = event.dataItems.filter(d => d.selected === true)
      this.updateAllSelectedHeader()
    },
    goToNewLocation: function () {
      //
    },
    unlinkGroups: async function () {
      this.showModalUnlinkGroups = !this.showModalUnlinkGroups
    },
    unlinkUserResponsable: async function () {
      this.showModalUnlinkUserResponsable = !this.showModalUnlinkUserResponsable
    },
    executeAction: async function (action) {
      this.selectedAction = action
      if (this.selectedAction.IdAccion === 1 || this.selectedAction.IdAccion === 12) { // descargar
        this.showModal = true
      } else if (this.selectedAction.IdAccion === 11) { // archivas sin descargar
        this.showModalArchivar = true
      } else if (this.selectedAction.IdAccion === 3) { // borrar
        this.showModalDelete = true 
      } else if (this.selectedAction.IdAccion === 4) { // tramitar
        this.showModalTramitar = true 
      } else if (this.selectedAction.IdAccion === 100) { // vincular grupos
        this.toggleDialogs()
      } else if (this.selectedAction.IdAccion === 101) { // desvincular grupos
        this.unlinkGroups()
      } else if (this.selectedAction.IdAccion === 102) { // Reasignar propietario a grupo
        this.toggleDialogReasign()
      } else if (this.selectedAction.IdAccion === 200) { // eliminar alerta email error
        this.remmoveErrorOrResendMailHandler()
      } else if (this.selectedAction.IdAccion === 202) { // reenviar emails en error
        this.remmoveErrorOrResendMailHandler(true)
      } else if (this.selectedAction.IdAccion === 201) { // eliminar alerta peticion api error
        this.remmoveErrorPetitionAPIHandler()
      } else if (this.selectedAction.IdAccion === 401) { // Añadir metadato
        this.toggleDialogMetadato()
      } else if (this.selectedAction.IdAccion === 500) { // Reasignar usuario responsable
        this.toggleDialogUserResponsable()
      } else if (this.selectedAction.IdAccion === 501) { // Desvincular usuario responsable
        this.unlinkUserResponsable()
      } else if (this.selectedAction.IdAccion === 600) { // Aceptar sugerencias IA
        this.toggleAcceptSuggestIA()
      } else if (this.selectedAction.IdAccion === 601) { // Rechazar sugerencias IA
        this.toggleCancelSuggestIA()
      } else if (this.selectedAction.IdAccion === 22) { // Enviar sugerencias IA
        this.enviaraiaHandler()
      } else if (this.selectedAction.IdAccion === 603) { // Reintentar envío sugerencias IA
        this.reintentarenviosiaHandler()
      } else if (this.selectedAction.IdAccion === 603) { // Reintentar envío sugerencias IA
        this.reintentarenviosiaHandler()
      } else if (this.selectedAction.IdAccion === 700) { // Quitar alerta de error reincidente
        this.removeRecurringErrorAlertHandler()
      } else if (this.selectedAction.IdAccion === 8) { // Descarga local
        if (this.hasPermRenombradoFicherosZIP) {
          this.downloadZipToggleDialog()
        } else {
          this.downloadLocal()
        }
      } else if (this.selectedAction.IdAccion === 9 || this.selectedAction.IdAccion === 19) { // Enviar aviso email a elección
        this.newWhiteMailToggleDialog()
      } else if (this.selectedAction.IdAccion === 16 || this.selectedAction.IdAccion === 20) { // Enviar aviso email vinculados
        if (this.hasModuleCustomMails) {
          this.toggleTextoCorreo()
        } else {
          this.sendMailAVinculadosHandler()
        }
      } else if (this.selectedAction.IdAccion === 17) { // Rechazar (Módulo de aprobación)
        this.toggleMotivoRechazo()
      } else if (this.selectedAction.IdAccion === 300) { // Exclusión de organismo
        this.showModalOrganismo = true
      } else if (this.selectedAction.IdAccion === 21) { // aplicar reglas manualmente
        this.showModalApplyRules = true 
      } else {
        this.executeActionHandler()
      }
    },
    toggleAcceptSuggestIA () {
      this.showModalAcceptSuggestIA = !this.showModalAcceptSuggestIA
    },
    toggleCancelSuggestIA () {
      this.showModalCancelSuggestIA = !this.showModalCancelSuggestIA
    },
    toggleMotivoRechazo () {
      this.showModalRechazo = !this.showModalRechazo
    },
    newWhiteMailToggleDialog () {
      this.showModalWhiteMail = !this.showModalWhiteMail
    },
    downloadZipToggleDialog () {
      this.showModalDownloadZip = !this.showModalDownloadZip
    },
    applyDownloadZipDialog: async function (form) {
      await this.downloadLocal(form)
      this.downloadZipToggleDialog()
    },
    applyNewWhiteMailDialog: async function (form) {
      if (form.GestionarListaBlancaGrupos) {
        this.auxGroupsMail = {
          valueTo: form.valueTo,
          valueCC: form.valueCC,
          valueCCO: form.valueCCO,
          TextoCorreo: form.TextoCorreo,
          AsuntoCorreo: form.AsuntoCorreo,
        }
        this.linkMyGroupsToggleDialog()
      } else {
        this.newWhiteMailDialogHandler(form)
      }
      this.showModalWhiteMail = false
    },
    applyLinkMyGroupsDialog (grupos) {
      this.newWhiteMailDialogHandler(this.auxGroupsMail, grupos)
    },
    applyTextoCorreo (form) {
      this.sendMailAVinculadosHandler(form)
    },
    rechazoDialogHandler: async function (MotivoRechazo) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          MotivoRechazo: MotivoRechazo,
          idNotificaciones: this.selected.map(x => x.IDInterno),
        }
        const response = await sendRejectNEO(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.showModalRechazo = false
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.data = await this.applyFilters()
        this.downloadNotificationDataByStatus(this.status)
        bus.$emit('changeIt', 'changed menu')
        this.$store.commit('setIsLoading', false)
      }
    },
    newWhiteMailDialogHandler: async function (emails, grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Emails: emails.valueTo, 
          EmailsCC: emails.valueCC, 
          EmailsCCO: emails.valueCCO, 
          idNotificaciones: this.selected.map(x => x.IDInterno),
          idGrupos: grupos,
          TextoCorreo: emails.TextoCorreo,
          AsuntoCorreo: emails.AsuntoCorreo,
        }
        const response = await sendAvisoCorreoManual(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.showModalLinkMyGroups = false
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.data = await this.applyFilters()
      }
    },
    downloadLocal: async function (form = null) {
      this.$store.commit('app/setLoading', true)
      this.loader = true
      const payload = { 
        idsNEOs: this.selected.map(x => x.IDInterno), 
        campoMetadato: form?.value,
        contieneNombre: form?.nombre,
      }
      try {
        const response = await downloadDocsNEO(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          const pathDescarga = joinUrl(getApiBaseUrl(), 'api/adjuntos/downloadtempfile?guid=' + response.Respuesta)
          console.log(pathDescarga)
          
          window.location.href = pathDescarga
        }
        // const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        // const link = document.createElement('a')
        // link.href = window.URL.createObjectURL(blob)
        // let filename = 'DocumentosNEO.zip'
        // filename = decodeURI(filename)
        // link.download = filename
        // link.click()
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loader = false
      }
    },
    executeActionHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const idNEOs = []
        const selected = this.selected
        const estado = this.status
        if (this.isNotice || this.isNotificationsGeneral) {
          selected.forEach((s) => {
            idNEOs.push({ IDNEO: s.IDInterno, Estado: s.Estado.Id })
          })
        } else {
          selected.forEach((s) => {
            idNEOs.push({ IDNEO: s.IDInterno, Estado: estado })
          })
        }
        const IdAccion = this.selectedAction.IdAccion
        const response = await updateNotificationStatus(IdAccion, { NEOs: idNEOs, IdAccion })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
        this.downloadNotificationDataByStatus(this.status)
        bus.$emit('changeIt', 'changed menu')
      }
    },
    downloadNotificationDataByStatus: async function (statusId) {
      // this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      try {
        const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
        filter.estadoDescarga = { label: 'Estado', value: this.status }
        // Limpiamos filtro Estado Extra
        delete filter.estadoDescargaExtra

        this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
        this.notificationActions = this.$store.getters['app/actionsForSelect'](this.status)
        this.data = await this.applyFilters()
      } catch (error) {
        console.log(error)
        this.doFeedback(this.$i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    goToNewNotification: function () {
      this.$router.push({ name: 'notification/new' })
    },
    sendMailAVinculadosHandler: async function (form) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          idNotificaciones: [], 
          TextoCorreo: form?.TextoCorreo,
          AsuntoCorreo: form?.AsuntoCorreo,
        }
        for (const element of this.selected) {
          payload.idNotificaciones.push(element.IDInterno)
        }
        const response = await sendMailNEOVinculados(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        if (this.hasModuleCustomMails) {
          this.toggleTextoCorreo()
        }
      }
      this.data = await this.applyFilters()
    },
    remmoveErrorOrResendMailHandler: async function (resend = false) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idsNEOs: [] }
        for (const element of this.selected) {
          payload.idsNEOs.push(element.IDInterno)
        }
        let response = null
        if (resend) {
          response = await reenviarEmailsErrorNEO(payload)
        } else {
          response = await quitarEnviarEmailError(payload)
        }
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    remmoveErrorPetitionAPIHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idsNEOs: [] }
        for (const element of this.selected) {
          payload.idsNEOs.push(element.IDInterno)
        }
        const response = await quitarPeticionAPIError(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.$store.dispatch('app/getAnnouncementsList')
        }
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    applyRulesManualHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idsNEOs: [] }
        for (const element of this.selected) {
          payload.idsNEOs.push(element.IDInterno)
        }
        const response = await aplicarreglasneos(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        this.doFeedback()
        console.error(error)
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    unlinkGroupsHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = []
        for (const element of this.selected) {
          payload.push(element.IDInterno)
        }
        const response = await unlinkNEOGroupsMultiple(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    unlinkUserResponsableHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idNotificaciones: [] }
        payload.idNotificaciones = this.selected.map(x => x.IDInterno)
        const response = await asignarusuarioresponsableneos(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    executeIAAction: async function (apiFn) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { idsNEOs: this.selected.map(x => x.IDInterno) }
        const response = await apiFn(payload)
        if (response.blnError) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      this.data = await this.applyFilters()
    },
    acceptSuggestIAHandler: async function () {
      await this.executeIAAction(aceptarsugerencias)
    },
    enviaraiaHandler: async function () {
      await this.executeIAAction(enviaraia)
    },
    reintentarenviosiaHandler: async function () {
      await this.executeIAAction(reintentarenviosia)
    },
    removeRecurringErrorAlertHandler: async function () {
      await this.executeIAAction(quitaravisoreincidenciaerrores)
    },
    cancelSuggestIAHandler: async function () {
      await this.executeIAAction(rechazarsugerencias)
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    toggleColumnasMetadatosDialog () {
      this.columnasMetadatosPanel = !this.columnasMetadatosPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>

<style lang='scss' scoped>
</style>
